/*!
  Atom, by Koding Themes
  video-player.js
  https://kodingthemes.com
*/

!function(e){"undefined"==typeof module?this.charming=e:module.exports=e}(function(e,n){"use strict";n=n||{};var t=n.tagName||"span",o=null!=n.classPrefix?n.classPrefix:"char",r=1,a=function(e){for(var n=e.parentNode,a=e.nodeValue,c=a.length,l=-1;++l<c;){var d=document.createElement(t);o&&(d.className=o+r,r++),d.appendChild(document.createTextNode(a[l])),n.insertBefore(d,e)}n.removeChild(e)};return function c(e){for(var n=[].slice.call(e.childNodes),t=n.length,o=-1;++o<t;)c(n[o]);e.nodeType===Node.TEXT_NODE&&a(e)}(e),e});

// The Slideshow class.
class Slideshow {
  constructor(el) {
    this.DOM = {
      el: el
    };
    this.config = {
      slideshow: {
        delay: 3000,
        pagination: {
          duration: 3,
        }
      }
    };
    // Set the slideshow
    this.init();
  }
  init() {
    var self = this;
    // Charmed title
    this.DOM.slideTitle = this.DOM.el.querySelectorAll('.slide-title');
    this.DOM.slideTitle.forEach((slideTitle) => {
      charming(slideTitle);
    });
    // Set the slider
    var autoplay = {};
    if (this.DOM.el.dataset.autoplay == 'true') {
      autoplay = {
        delay: this.config.slideshow.delay,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      }
    } else {
      autoplay = false;
    }
    this.slideshow = new Swiper(this.DOM.el, {
      loop: false,
      autoplay: autoplay,
      speed: 1000,
      preloadImages: true,
      updateOnImagesReady: true,
      pagination: {
        el: '.swiper-slideshow-pagination',
        clickable: true,
        bulletClass: 'swiper-slideshow-pagination-item',
        bulletActiveClass: 'active',
        clickableClass: 'swiper-slideshow-pagination-clickable',
        modifierClass: 'swiper-slideshow-pagination-',
        renderBullet: function(index, className) {
          var slideIndex = index,
            number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);
          var paginationItem = '<span class="swiper-slideshow-pagination-item">';
          paginationItem += '<span class="pagination-number">' + number + '</span>';
          paginationItem = (index <= 8) ? paginationItem + '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' : paginationItem;
          paginationItem += '</span>';
          return paginationItem;
        },
      },
      // Navigation arrows
      navigation: {
        nextEl: '.slideshow-navigation-button.next',
        prevEl: '.slideshow-navigation-button.prev',
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      on: {
        init: function() {
          self.animate('next');
        },
      }
    });
    // Init/Bind events.
    this.initEvents();
    var VideoSlider = this.DOM.el;
    var slideshow = this.slideshow;
    if (this.DOM.el.dataset.autoplay == 'true') {
      VideoSlider.addEventListener('mouseenter', function(e) {
        slideshow.autoplay.stop();
      });
      VideoSlider.addEventListener('mouseleave', function(e) {
        slideshow.autoplay.start();
      });
    }
  }
  initEvents() {
    this.slideshow.on('paginationUpdate', (swiper, paginationEl) => this.animatePagination(swiper, paginationEl));
    this.slideshow.on('slideNextTransitionStart', () => this.animate('next'));
    this.slideshow.on('slidePrevTransitionStart', () => this.animate('prev'));
  }
  animate(direction = 'next') {
    // Get the active slide
    this.DOM.activeSlide = this.DOM.el.querySelector('.swiper-slide-active');

    if (this.DOM.activeSlide != null) {
      this.DOM.activeSlideImg = this.DOM.activeSlide.querySelector('.slide-image');
      this.DOM.activeSlideTitle = this.DOM.activeSlide.querySelector('.slide-title');
      this.DOM.activeSlideTitleLetters = this.DOM.activeSlideTitle.querySelectorAll('span');

      // Reverse if prev
      this.DOM.activeSlideTitleLetters = direction === "next" ? this.DOM.activeSlideTitleLetters : [].slice.call(this.DOM.activeSlideTitleLetters).reverse();
      // Get old slide
      this.DOM.oldSlide = direction === "next" ? this.DOM.el.querySelector('.swiper-slide-prev') : this.DOM.el.querySelector('.swiper-slide-next');
      if (this.DOM.oldSlide) {
        // Get parts
        this.DOM.oldSlideTitle = this.DOM.oldSlide.querySelector('.slide-title'),
          this.DOM.oldSlideTitleLetters = this.DOM.oldSlideTitle.querySelectorAll('span');
        // Animate
        this.DOM.oldSlideTitleLetters.forEach((letter, pos) => {
          gsap.to(letter, {
            duration: 0.3,
            ease: 'quart.in',
            delay: (this.DOM.oldSlideTitleLetters.length - pos - 1) * .04,
            y: '50%',
            opacity: 0
          });
        });
      }
      // Animate title
      this.DOM.activeSlideTitleLetters.forEach((letter, pos) => {
        gsap.to(letter, {
          duration: 0.6,
          ease: 'back.out',
          delay: pos * .05,
          startAt: {
            y: '50%',
            opacity: 0
          },
          y: '0%',
          opacity: 1
        });
      });
      // Animate background
      gsap.to(this.DOM.activeSlideImg, {
        duration: 1.5,
        ease: 'expo.out',
        startAt: {
          x: direction === 'next' ? 200 : -200
        },
        x: 0,
      });
    }
  }
  animatePagination(swiper, paginationEl) {
    // Animate pagination
    this.DOM.paginationItemsLoader = paginationEl.querySelectorAll('.pagination-separator-loader');
    this.DOM.activePaginationItem = paginationEl.querySelector('.swiper-slideshow-pagination-item.active');
    if (!this.DOM.activePaginationItem) return;
    this.DOM.activePaginationItemLoader = this.DOM.activePaginationItem.querySelector('.pagination-separator-loader');
    videoControls(swiper.activeIndex);
    // Reset and animate
    gsap.set(this.DOM.paginationItemsLoader, {
      scaleX: 0
    });
    gsap.to(this.DOM.activePaginationItemLoader, {
      duration: this.config.slideshow.pagination.duration,
      startAt: {
        scaleX: 0
      },
      scaleX: 1,
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  videoSliderAndControls();
});
document.addEventListener("shopify:section:load", function() {
  videoSliderAndControls();
});
document.addEventListener("shopify:section:reorder", function() {
  videoSliderAndControls();
});
function videoSliderAndControls() {
  var allVideoSliders = document.querySelectorAll('.video-slideshow');
  allVideoSliders.forEach(function(VideoSlider) {
    var slideshow = new Slideshow(VideoSlider);
    // controls hover effect
    var slideControls = VideoSlider.querySelectorAll('.video-slide-pause-button,.video-slideshow .slideshow-navigation');
    if (slideControls.length > 0 && window.innerWidth > 1023) {
      VideoSlider.addEventListener('mouseover', function(e) {
        slideControls.forEach(function(c) {
          c.style.display = 'flex';
        });
      });
      VideoSlider.addEventListener('mouseout', function(e) {
        slideControls.forEach(function(c) {
          c.style.display = 'none';
        });
      });
    }
  });
  videoControls(null);

  // if there is only one slide and autoplay true
  allVideoSliders.forEach(function(slider) {
    var videoSlides = slider.querySelectorAll('.full-width-video-slide');
    var autoplay = slider.dataset.autoplay;
    var audio = slider.dataset.audio;
    if (autoplay == 'true' && videoSlides.length == 1 && audio == 'false') {
      var slide = videoSlides[0];
      var video = slide.querySelector('video');
      if (video) video.play();
      var iframe = slide.querySelector('iframe');
      if (iframe) {
        iframe.src = iframe.src.replace("autoplay=0", "autoplay=1");
      }
      var slideControls = slide.querySelectorAll('.video-slide-pause-button a');
      slideControls.forEach(function(control) {
        if (control.classList.contains('video-play')) {
          control.style.display = 'none';
        } else {
          control.style.display = 'block';
        }
      });
    }
  });
}

function videoControls(activeIndex) {
  // video controls
  var videoSlides = document.querySelectorAll('.full-width-video-slide');

  // Pause all videos/iframes first
  videoSlides.forEach(function(slide) {
    var video = slide.querySelector('video');
    if (video) video.pause();
    var iframe = slide.querySelector('iframe');
    if (iframe) {
      iframe.src = iframe.src.replace("autoplay=1", "autoplay=0");
      var poster = slide.querySelector('.iframe-poster-image');
      if (poster) poster.style.display = 'block';
    }
  });

  // Set up controls for each slide
  videoSlides.forEach(function(slide) {
    var slideVideo = slide.querySelector('video');
    var slideIframe = slide.querySelector('iframe');
    var slideIframePoster = slide.querySelector('.iframe-poster-image');
    var slideControls = slide.querySelectorAll('.video-slide-pause-button a');

    // audio buttons
    var slideAudioControls = slide.querySelectorAll('.video-slide-audio-button a');
    if (slideAudioControls.length > 0) {
      slideAudioControls.forEach(function(control) {
        if (control.classList.contains('audio-pause')) {
          control.style.display = 'none';
        } else {
          control.style.display = 'flex';
        }
        control.onclick = function(e) {
          e.preventDefault();
          if (control.classList.contains('audio-pause')) {
            control.style.display = 'none';
            control.closest('.video-slide-audio-button').querySelector('.audio-play').style.display = 'flex';
            if (slideVideo) slideVideo.muted = true;
          } else {
            control.style.display = 'none';
            control.closest('.video-slide-audio-button').querySelector('.audio-pause').style.display = 'flex';
            if (slideVideo) slideVideo.muted = false;
          }
        };
      });
    }

    slideControls.forEach(function(control) {
      if (Shopify.designMode === true) control.closest('.video-slide-pause-button').style.display = 'flex';
      if (control.closest('.iframe-video-slide')) control.closest('.slide-image').classList.remove('iframe-video-slide-played');
      if (control.classList.contains('video-pause')) {
        control.style.display = 'none';
      } else {
        control.style.display = 'block';
      }
      control.onclick = function(e) {
        e.preventDefault();
        if (control.classList.contains('video-pause')) {
          control.style.display = 'none';
          control.closest('.video-slide-pause-button').querySelector('.video-play').style.display = 'block';
          if (slideVideo) slideVideo.pause();
          if (slideIframe) {
            if (!Shopify.designMode) slideIframe.src = slideIframe.src.replace("autoplay=1", "autoplay=0");
            control.closest('.video-slide-pause-button').style.display = 'none';
            if (control.closest('.iframe-video-slide')) control.closest('.slide-image').classList.remove('iframe-video-slide-played');
            if (slideIframePoster) slideIframePoster.style.display = 'block';
          }
        } else {
          control.style.display = 'none';
          control.closest('.video-slide-pause-button').querySelector('.video-pause').style.display = 'block';
          if (slideVideo) slideVideo.play();
          if (slideIframe) {
            if (!Shopify.designMode) slideIframe.src = slideIframe.src.replace("autoplay=0", "autoplay=1");
            control.closest('.video-slide-pause-button').style.display = 'none';
            if (control.closest('.iframe-video-slide')) control.closest('.slide-image').classList.add('iframe-video-slide-played');
            if (slideIframePoster) slideIframePoster.style.display = 'none';
          }
        }
      };
    });
  });
}
